import styled from 'styled-components'
import Box from '@/components/Box/Box'

const Wrapper = styled.div`
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    display: ${({ enableFlex }) => (enableFlex ? 'flex' : 'block')};
    flex-wrap: wrap;
  }
  padding-top: ${props => props.isAFSProduct && '44px'};
`

const FullWidth = styled.div`
  width: 100%;
`

const MediaGalleryBox = styled(Box)`
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    padding-block: 0 !important;
    margin-bottom: 0;
  }
`

export { Wrapper, FullWidth, MediaGalleryBox }
